import React from 'react';
import Loadable from '@react-loadable/revised';

export const recaptchaMap = {
    'v3': Loadable({ loader: () => import('./RecaptchaV3'), loading: () => <div></div> }),
}